/** 卡片尺寸-宽度 */
export const CARD_SIZE_WIDTH = 100;
/** 卡片尺寸-高度 */
export const CARD_SIZE_HEIGHT = 100;
/** 卡片尺寸-间隙 */
export const CARD_SIZE_SPACE = 7;
